var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.as,
    _vm._g(
      _vm._b(
        {
          tag: "component",
          class: _vm.computedClass,
          style: { objectFit: _vm.objectFit },
        },
        "component",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm.$slots.default ? _vm._t("default") : _vm._e()],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }